import {Modal, Table, Typography} from 'antd';
import {moneyMask} from '../../utils/utils';
import {GREE_1} from '../../utils/colors';

const columns = [
    {title: 'Produto', dataIndex: 'product_name', key: 'product_name'},
    {
        title: 'Preço anterior',
        dataIndex: 'price_snapshot',
        key: 'price_snapshot',
        render: (v) => <Typography.Text delete style={{color: '#999'}}>R$ {moneyMask(v)}</Typography.Text>,
    },
    {
        title: 'Preço atual',
        dataIndex: 'current_price',
        key: 'current_price',
        render: (v) => <Typography.Text strong style={{color: GREE_1}}>R$ {moneyMask(v)}</Typography.Text>,
    },
];

export default function PriceChangedModal({items, loading, onConfirm}) {
    return (
        <Modal
            open={items.length > 0}
            title="Preços atualizados"
            onOk={onConfirm}
            okText="Atualizar preços"
            confirmLoading={loading}
            closable={false}
            maskClosable={false}
            footer={(_, {OkBtn}) => <OkBtn/>}
        >
            <Typography.Paragraph>
                Os preços dos itens abaixo foram alterados desde que foram adicionados ao carrinho:
            </Typography.Paragraph>
            <Table
                dataSource={items}
                rowKey="id"
                pagination={false}
                size="small"
                columns={columns}
            />
        </Modal>
    );
}
